export default __webpack_public_path__ + "static/media/cp_geo_id.ebd28216.svg";